export default __webpack_public_path__ + "static/media/BANNER-FULL_Covid_01_Saliva.dd7d8489.png";